const configuredApiUrl = process.env.VUE_APP_API_URL || 'https://api.jobifull.eu/';

export const apiBaseUrl = configuredApiUrl.replace(/\/+$/, '');

export default apiBaseUrl;
